const GenSearchData =[
      {
        limit:151,
        offset:0
      },{
        limit:100,
        offset:151
      },{
        limit:135,
        offset:251
      },{
        limit:107,
        offset:386
      },{
        limit:156,
        offset:493
      },{
        limit:72,
        offset:649
      },{
        limit:88,
        offset:721
      },{
        limit:96,
        offset:809
      }
]

export default GenSearchData